import { IlogisticServiceDetailsToolsData } from 'types/services';
import { create } from 'zustand';

interface ILogisticServicesState {
  toolsSelected: Pick<IlogisticServiceDetailsToolsData, 'serial' | 'productId'>[] | null;
  setToolsSelected: (toolsSelected: Pick<IlogisticServiceDetailsToolsData, 'serial' | 'productId'>[] | null) => void;
  openDownloadModal: boolean;
  setOpenDownloadModal: (openDownloadModal: boolean) => void;
}

const useLogisticServicesState = create<ILogisticServicesState>(set => ({
  toolsSelected: null,
  setToolsSelected: toolsSelected => set({ toolsSelected }),
  openDownloadModal: false,
  setOpenDownloadModal: openDownloadModal => set({ openDownloadModal })
}));

export default useLogisticServicesState;
